import { ResetPasswordForm } from '@/features/identity/components/ResetPasswordForm';

export function ResetPasswordPage() {
  return <ResetPasswordForm />;
}
